import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { footerData } from '../footerData';

type Props = {
  baseDomain?: string;
};

export default function NavigateFooter({ baseDomain }: Props) {
  const { locale, defaultLocale } = useRouter();
  const { t } = useTranslation();

  return (
    <div className="desktop:mt-6 desktop:grid-cols-6 grid grid-cols-2 gap-6">
      {footerData.map((item) => (
        <div key={item.id} className="desktop:space-y-6 space-y-4 pr-2">
          <h2 className="text-body16 text-neutral-90 desktop:text-subtitle20 text-left font-bold">
            {t(`system:footer.${item.title}`)}
          </h2>
          <ul className="text-body14 text-neutral-90 desktop:space-y-4 desktop:text-body16 space-y-3 text-left">
            {item.items.map((l, idx) => (
              <li key={idx}>
                <Link
                  href={
                    l.external
                      ? l.href
                      : `${baseDomain}${
                          locale && locale !== defaultLocale ? `/${locale}` : ''
                        }${l.href}`
                  }
                  rel="noreferrer"
                  passHref
                  locale={locale}
                  title={l.name}
                  className="hover:text-neutral-70"
                  target={l.external ? '_blank' : '_self'}
                  aria-label={l.name}
                >
                  {t(`system:footer.${l.name}`)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
